import { IconWrap, SingleNeutralActionsEditIcon, Tooltip } from '@libs/ui/ds'
import { usePlanningTranslation } from '@libs/utils/translations'
import { CardFooter } from '@spa/scenes/Plannings/components'
import type { ShiftModel } from '@spa/scenes/Plannings/redux/models/Shift'
import type { FC } from 'react'
import React from 'react'

type Props = {
  shift: ShiftModel
}

const ShiftEditedByEmployee: FC<Props> = ({ shift }) => {
  const { t } = usePlanningTranslation()

  if (
    !shift.real_hours_last_modified_by_employee_at &&
    !shift.real_hours_declared_correct_at
  ) {
    return null
  }

  const mostRecentDeclarationDate = [
    shift.real_hours_last_modified_by_employee_at,
    shift.real_hours_declared_correct_at
  ]
    .filter(date => date)
    .sort()
    .reverse()[0]

  return (
    <CardFooter.ActionItem>
      <Tooltip
        data-testid={`edited-by-employee-tooltip-${shift.id}`}
        label={t('weekly.card.updatedByEmployee', {
          date: mostRecentDeclarationDate
        })}
      >
        <IconWrap icon={<SingleNeutralActionsEditIcon />} size='s' />
      </Tooltip>
    </CardFooter.ActionItem>
  )
}

export default ShiftEditedByEmployee
